
import { AiFillTwitterCircle, AiFillLinkedin, AiFillInstagram, AiFillFacebook } from 'react-icons/ai'
import React from 'react'
import "./Footer.css"
const Footer = () => {
  return (
    <>
        <hr></hr>
        <div className='footer'> 
            <div className='footer-redes'>
                <h4>Seguinos en redes</h4>
                <div className='footer-redes-icons'>
                    <a href='https://www.facebook.com/medicus.medicinaprepaga/?fref=ts' target='_blank' rel="noopener noreferrer">
                        <AiFillFacebook />
                    </a>
                    <a href='https://twitter.com/medicus_sa' target='_blank' rel="noopener noreferrer">
                        <AiFillTwitterCircle />
                    </a>
                    <a href='https://www.linkedin.com/company/medicus-s.a.' target='_blank' rel="noopener noreferrer">
                        <AiFillLinkedin />
                    </a>
                    <a href='https://www.instagram.com/medicus_sa/' target='_blank' rel="noopener noreferrer">
                        <AiFillInstagram />
                    </a>
                </div>
            </div>
            <div className='footer-preguntas-frecuentes'>
                <a href='https://medicus.com.ar/#/preguntas-frecuentes' target='_blank' rel="noopener noreferrer">
                    <h4>Preguntas frecuentes</h4>
                </a>
                <p>Te sugerimos ingresar para resolver inquietudes generales</p>
            </div>
        </div>
    </>
  )
}

export default Footer